import request from "./request";
import store from "@/store";
import { handleFetchResponse } from "@/utils/fetchResponse";
// 将dating消息发送到后台（暂时不用）
export const sendDatingMessageToBackend = (data) => {
  console.log(data, "data");
  return request({
    url: "/mf/chat/dtwsmsg",
    method: "post",
    headers: {
      isEncrypt: false,
    },
    data,
  });
};

// 通知后端用户发送了媒体消息或媒体邮件
export const notifyBackendMediaSent = (data) => {
  console.log("通知后端媒体发送:", data);
  return request({
    url: "/mf/chat/messageTypeCount",
    method: "post",
    headers: {
      isEncrypt: false,
    },
    data: {
      ...data,
      chatType: data.chatType == "image" ? "photo" : data.chatType, // AUDIO("audio"),VIDEO("video"),PHOTO("photo"),EMAIL("email"),
    },
  });
};
// https://api.dating.com/dialogs/letters/50866854742?direction=in&omit=0&read=true&replied=false&select=20
// export const getDatingLetters = (data) => {
//   return request({
//     url: `/dating-api/dialogs/letters/${data.id}?direction=in&omit=0&read=true&replied=false&select=2000`,
//     method: 'get',
//     platform: 'dating',
//     noTips: true,
//     headers: {
//       isEncrypt: false,
//       'Cache-Control': 'no-cache, no-store, must-revalidate', // 禁止缓存并要求重新验证
//       Pragma: 'no-cache', // HTTP/1.0 兼容的缓存控制
//       Expires: '0', // 设置为0表示立即过期
//       authorization: `Token token="${data.token}"`,
//     },
//   });
// };
// https://api.dating.com/dialogs/letters/50866854742?direction=in&omit=0&read=true&replied=false&select=20
// 获取未回复邮件
export const getDatingLetters = (data) => {
  const baseUrl = process.env.VUE_APP_BASE_API_DT2;
  return new Promise((resolve, reject) => {
    return fetch(
      `${baseUrl}/dialogs/letters/${data.id}?direction=in&omit=0&replied=false&select=2000&introductory=false`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token token="${data.token}"`,
        },
      }
    )
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取邮件数量信息
export const getDatingEventsTotal = (data) => {
  const baseUrl = process.env.VUE_APP_BASE_API_DT2;
  let params = {
    ...data,
  };
  delete params.id;
  delete params.token;
  return new Promise((resolve, reject) => {
    return fetch(
      `${baseUrl}/users/${data.id}/events?${new URLSearchParams(
        params
      ).toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token token="${data.token}"`,
          accept: "application/json+vnd.sdv.numeric",
        },
      }
    )
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取邮件列表
export const getDatingEventsLetter = (data) => {
  const baseUrl = process.env.VUE_APP_BASE_API_DT2;
  let params = {
    ...data,
  };
  delete params.id;
  delete params.token;
  return new Promise((resolve, reject) => {
    return fetch(
      `${baseUrl}/users/${data.id}/events?${new URLSearchParams(
        params
      ).toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token token="${data.token}"`,
          accept: "application/json",
        },
      }
    )
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// https://api.dating.com/dialogs/letters/49293890042?omit=0&participant=107946485431&select=10
// 获取更多邮件
export const getDatingEventsLetterDetail = (data) => {
  const baseUrl = process.env.VUE_APP_BASE_API_DT2;
  let params = {
    ...data,
  };
  delete params.id;
  delete params.token;
  return new Promise((resolve, reject) => {
    return fetch(
      `${baseUrl}/dialogs/letters/${data.id}?${new URLSearchParams(
        params
      ).toString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          authorization: `Token token="${data.token}"`,
          accept: "application/json",
        },
      }
    )
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

// https://api.dating.com/dialogs/letters/{0}/{1}/{2}
// 获取dating邮件详情
export const getEmailDetail = (data) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;

    const url = `${baseUrl}/dialogs/letters/${data.recipient}/${data.sender}/${data.id}`;

    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${data.token}"`,
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

// https://api.dating.com/v2/dialogs/cheers/{0}/sets?attendeeId={1}&bonuses=false&masks=false&product=dating
// 获取礼物列表
export const getDatingCheer = (data) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;

    const url = `${baseUrl}/v2/dialogs/cheers/${data.platformUserId}/sets?attendeeId=${data.userId}&bonuses=false&masks=false&product=dating`;
    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${data.token}"`,
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取表情
// https://api.dating.com/v2/smiles/{0}/{1}
export const getDatingSmile = (data) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const url = `${baseUrl}/v2/smiles/${data.platformUserId}/${data.userId}`;
    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取贴图
// https://api.dating.com/v3/stickers/{0}?attendeeId={1}&features=vip
export const getDatingSticker = (data) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const url = `${baseUrl}/v3/stickers/${data.platformUserId}?attendeeId=${data.userId}&features=vip`;
    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${data.token}"`,
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

// https://api.dating.com/dialogs/letters/covers
// 获取邮件封面列表
export const getDatingLettersCovers = (data) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    return fetch(`${baseUrl}/dialogs/letters/covers`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        handleFetchResponse(
          response,
          (res) => {
            console.log(res, "res");
            const coverRes = res.map((item) => {
              return {
                cover: item,
                // "https://api0.dating.com/dialogs/letters/covers/f2f2f2.620x.nc"
                coverUrl: `https://api0.dating.com/dialogs/letters/covers/${item}.620x.nc`,
              };
            });
            resolve(coverRes);
          },
          (err) => {
            reject(err);
          }
        );
      })
      .catch((err) => {
        reject(err);
      });
  });
};
// https://api.dating.com/users/109536004231
// 获取用户信息
export const getDatingUserInfo = (id) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const url = `${baseUrl}/users/${id}`;
    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// https://api.dating.com/users/{0}/photos  图片接口
// https://api.dating.com/users/{0}/interests  兴趣接口
// https://api.dating.com/users/{0}/videos  视频接口
// https://api.dating.com/v2/users/{0}/preferences  寻找对象接口
// 获取dating用户兴趣
export const getDatingUserInterests = (id) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const url = `${baseUrl}/users/${id}/interests`;
    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取dating用户寻找对象
export const getDatingUserPreferences = (id) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const url = `${baseUrl}/v2/users/${id}/preferences`;
    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取dating用户照片
export const getDatingUserPhotos = (id) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const url = `${baseUrl}/users/${id}/photos`;
    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

// 获取dating用户视频
export const getDatingUserVideos = (id) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const url = `${baseUrl}/users/${id}/videos`;
    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

// 获取dating消息列表
// https://api.dating.com/dialogs/messages/{0}:{1}?omit=0&select=50
export const dialogsmessages = (platformUserId, userId, params = {}) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const userInfo =
      store.getters["socket/getUserInfo"](platformUserId) ||
      store.getters["socket/getUserInfo"](userId);

    // 构建查询参数
    const queryParams = new URLSearchParams();
    if (params.omit !== undefined) queryParams.append("omit", params.omit);
    if (params.select !== undefined)
      queryParams.append("select", params.select);

    const url = `${baseUrl}/dialogs/messages/${userId}:${platformUserId}${
      queryParams.toString() ? "?" + queryParams.toString() : ""
    }`;

    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${userInfo.token}"`,
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取dating邮件详情
export const getEmailMessages = (platformUserId, userId, id, tokenId) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const userInfo = store.getters["socket/getUserInfo"](
      tokenId || platformUserId || userId
    );

    const url = `${baseUrl}/dialogs/letters/${userId}/${platformUserId}/${id}`;

    return fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${userInfo.token}"`,
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 向dating发送消息 0 platformUserId  1 userId
export const sendMessages = (platformUserId, userId, data) => {
  return new Promise((resolve, reject) => {
    // 根据环境使用不同的API地址
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const userInfo = store.getters["socket/getUserInfo"](platformUserId);
    // https://api.dating.com/dialogs/messages/{0}:{1}
    // {0} platformUserId {1} userId
    return fetch(`${baseUrl}/dialogs/messages/${platformUserId}:${userId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${userInfo.token}"`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

// 上传到dating
// https://api.dating.com/dialogs/usermedia/{0}/{1}  上传文件0 ： userId  1 ：platformUserId
export const uploadToDating = (platformUserId, userId, data) => {
  return new Promise((resolve, reject) => {
    // 根据环境使用不同的API地址
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const userInfo = store.getters["socket/getUserInfo"](platformUserId);

    const headers = {
      Authorization: `Token token="${userInfo.token}"`,
      "x-client": "dating-web",
    };

    // 根据数据类型设置正确的Content-Type
    if (data instanceof FormData) {
      // FormData会自动设置Content-Type为multipart/form-data，包含boundary
      // 不需要手动设置，让浏览器自动处理
    } else {
      // 如果不是FormData，设置为application/octet-stream用于二进制数据
      headers["Content-Type"] = "application/octet-stream";
    }

    return fetch(`${baseUrl}/dialogs/usermedia/${userId}/${platformUserId}`, {
      method: "POST",
      headers,
      body: data,
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取上传dating文件的
export const getDatingFile = (
  platformUserId,
  userId,
  fileId,
  returnUrl = true,
  type = "audio"
) => {
  const userInfo = store.getters["socket/getUserInfo"](platformUserId);
  const token = encodeURIComponent(`Token token="${userInfo.token}"`);
  const baseUrl = "https://api.dating.com";
  if (returnUrl && type == "audio") {
    // 返回文件URL
    return `${baseUrl}/dialogs/usermedia/${userId}/${platformUserId}/${fileId}?authorization=${token}`;
  } else if (returnUrl && type == "image") {
    return `${baseUrl}/dialogs/usermedia/${userId}/${platformUserId}/${fileId}.x400.scaleup.x1200.gallery?authorization=${token}`;
  } else if (returnUrl && type == "video") {
    return `${baseUrl}/dialogs/usermedia/${userId}/${platformUserId}/${fileId}.x.mp4?authorization=${token}`;
  }

  // 直接下载文件
  return new Promise((resolve, reject) => {
    const baseUrl2 = process.env.VUE_APP_BASE_API_DT2;
    const headers = {
      Authorization: `Token token="${userInfo.token}"`,
      "x-client": "dating-web",
      "Content-Type": "application/m4a",
    };

    return fetch(
      `${baseUrl2}/dialogs/usermedia/${userId}/${platformUserId}/${fileId}`,
      {
        method: "GET",
        headers,
      }
    )
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

/**
 * 获取dating邮件
 * @param {string} userId
 * @returns {Promise<{key: string, shard: string}>}
 */
export const getDatingEmail = (platformUserId, userId, requestId) => {
  return new Promise((resolve, reject) => {
    // 根据环境使用不同的API地址
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const userInfo = store.getters["socket/getUserInfo"](platformUserId);
    // https://api.dating.com/dialogs/letters/{0}/completions/new/{1}?request-id={2}&type=default
    // {0} platformUserId {1} userId {2} uuid
    return fetch(
      `${baseUrl}/dialogs/letters/${platformUserId}/completions/new/${userId}?request-id=${requestId}&type=default`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "x-client": "dating-web",
          Authorization: `Token token="${userInfo.token}"`,
        },
      }
    )
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取dating生成邮件token
// https://api.dating.com/tokens/49266959942/jwt/lilith
export const getDatingEmailToken = (platformUserId) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const userInfo = store.getters["socket/getUserInfo"](platformUserId);
    return fetch(`${baseUrl}/tokens/${platformUserId}/jwt/lilith`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${userInfo.token}"`,
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取AI生成邮件token
// https://copilot.theone.ai/api/v1/authenticate
export const getAIEmailToken = (token) => {
  return new Promise((resolve, reject) => {
    const params = {
      product: "cp",
      cp_back_host: "api.dating.com",
      token: token,
    };
    return fetch(`https://copilot.theone.ai/api/v1/authenticate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(params),
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 获取AI生成邮件内容
// https://copilot.theone.ai/api/v1/letter/generate
// {
//   "request_id": "b7b8c78d-b1a0-4b-a0-739d4377bca9"
// }
export const getAIEmailContent = (token, requestId) => {
  return new Promise((resolve, reject) => {
    return fetch(`https://copilot.theone.ai/api/v1/letter/generate`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        request_id: requestId,
      }),
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

// 向dating发送邮件
// https://api.dating.com/dialogs/letters/{0}/{1}
export const sendDatingEmailMessages = (platformUserId, userId, data) => {
  return new Promise((resolve, reject) => {
    // 根据环境使用不同的API地址
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const userInfo = store.getters["socket/getUserInfo"](platformUserId);
    // https://api.dating.com/dialogs/letters/{0}/{1}
    // {0} userId {1} platformUserId
    return fetch(`${baseUrl}/dialogs/letters/${userId}/${platformUserId}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${userInfo.token}"`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

// https://api.dating.com/users/{0}/contacts/{1}
export const sendDatingFavoriteMessage = ({
  platformUserId,
  userId,
  favorite,
}) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const userInfo = store.getters["socket/getUserInfo"](platformUserId);
    return fetch(`${baseUrl}/users/${platformUserId}/contacts/${userId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${userInfo.token}"`,
      },
      body: JSON.stringify({ favorite }),
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// 删除对话
// https://api.dating.com/users/{0}/events/{1}   platformUserId eventid
export const delDatingChat = (platformUserId, eventId) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const userInfo = store.getters["socket/getUserInfo"](platformUserId);
    return fetch(`${baseUrl}/users/${platformUserId}/events/${eventId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${userInfo.token}"`,
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

// https://api.dating.com/users/51226151442/moods
// 获取心情
export const getDatingMoods = (platformUserId) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    // const userInfo = store.getters['socket/getUserInfo'](platformUserId);
    return fetch(`${baseUrl}/users/${platformUserId}/moods`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        // Authorization: `Token token="${userInfo.token}"`,
      },
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};
// https://api.dating.com/users/51226151442/moods
// 修改心情
export const setDatingMoods = (platformUserId, data) => {
  return new Promise((resolve, reject) => {
    const baseUrl = process.env.VUE_APP_BASE_API_DT2;
    const userInfo = store.getters["socket/getUserInfo"](platformUserId);
    return fetch(`${baseUrl}/users/${platformUserId}/moods`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "x-client": "dating-web",
        Authorization: `Token token="${userInfo.token}"`,
      },
      body: JSON.stringify(data),
    })
      .then((response) => handleFetchResponse(response, resolve, reject))
      .catch((err) => {
        reject(err);
      });
  });
};

// https://api0.dating.com/users/50866854742/photos/63aa30d8ae18cebe.x400.scaleup.x1200.gallery

// https://api.dating.com/users/50866854742/photos/63aa30d8ae18cebe.x400.scaleup.x1200.gallery
export const getDatingThumbnail = (userId, fileId) => {
  return new Promise((resolve, reject) => {
    resolve(
      `https://api0.dating.com/users/${userId}/photos/${fileId}.x400.scaleup.x1200.gallery`
    );
  });
};
